import { useDaumPostcodePopup } from "react-daum-postcode";

import { KAKAO_ADDR_API_URL } from "App-config";

const KakaoAddrPopup = ({ btnText, className, addrHandleEvent }) => {
  const open = useDaumPostcodePopup(KAKAO_ADDR_API_URL);

  const handleComplete = (data) => {
    let fullAddress = data.address;
    let extraAddress = "";

    if (data.addressType === "R") {
      if (data.bname !== "") {
        extraAddress += data.bname;
      }
      if (data.buildingName !== "") {
        extraAddress +=
          extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
      }
      fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
    }
    addrHandleEvent(fullAddress);
  };

  const handleClick = () => {
    open({ onComplete: handleComplete });
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {btnText}
    </button>
  );
};

export default KakaoAddrPopup;
